import "./main.sass"
import {createElement, Frag, replaceChildren, Router} from "@opendaw/lib-jsx"
import {Promises} from "@opendaw/lib-runtime"
import {Terminator} from "@opendaw/lib-std"
import {TracksList} from "@/api"
import {BrowsePage} from "@/BrowsePage"
import {SinglePage} from "@/SinglePage"

(async () => {
    console.debug("booted")

    const listUrl = "https://api.opendaw.studio/music/list.php"
    const {status, value: response, error} = await Promises.tryCatch(fetch(listUrl)
        .then(res => res.json())
        .then(res => res as TracksList))

    if (status === "rejected") {
        alert(error)
        return
    }
    window.addEventListener("play", event => {
        const audios = document.querySelectorAll("audio")
        audios.forEach(audio => {
            if (audio !== event.target) {
                audio.pause()
            }
        })
    }, true)
    document.querySelector("#preloader")?.remove()
    replaceChildren(document.body, (
        <Frag>
            <Router
                runtime={new Terminator()}
                service={response}
                fallback={() => (
                    <div style={{flex: "1 0 0", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <span style={{fontSize: "50vmin"}}>404</span>
                    </div>
                )}
                routes={[
                    {
                        path: "/",
                        factory: () => (<BrowsePage trackList={response}/>)
                    },
                    {
                        path: "/track/*",
                        factory: SinglePage
                    }
                ]}/>
            <footer style={{fontSize: "11px", color: "#888", textAlign: "center", padding: "0.5rem", position: "sticky", bottom: "0", background: "black"}}>
                <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank">
                    All music is CC BY-NC-SA 4.0
                </a>
            </footer>
        </Frag>
    ))
})()